/**
 * Decodes a percent-encoded LinkedIn URL to its Unicode form.
 * e.g. https://www.linkedin.com/in/maciej-smoczy%C5%84ski → maciej-smoczński
 * Safe to call on already-decoded URLs (decodeURIComponent is idempotent for plain strings).
 */
export const decodeLinkedInUrl = (url: string): string => {
  try {
    return decodeURIComponent(url);
  } catch {
    return url;
  }
};

/**
 * onPaste handler for URL inputs that may contain percent-encoded characters.
 * Matches the (e, setValue) signature used by InputField and KInputField onPaste props.
 */
export const handleLinkedInUrlPaste = (
  e: React.ClipboardEvent<HTMLInputElement>,
  setValue: (_value: string) => void
): void => {
  e.preventDefault();
  setValue(decodeLinkedInUrl(e.clipboardData.getData('text').trim()));
};
